/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// window.addEventListener('load', () => {
//   console.log('Which will run only after page is fully loaded in background.');
//   $('product-payment-container.only_one-product-form__buy-buttons').show();
//   $('.product-form__dummy-add-button').hide();
  
//   $('.product-item__link.only_one-product-item__link').show();
//   $('.product-item__dummy-link').hide();
  
//   $('.product-item__quick-buy-button.only_one-product-item__quick-buy-button').show();
//   $('.product-item__dummy-quick-buy-button').hide();
// });
document.addEventListener('variant:changed', function(event) {
 let variant = event.detail.variant;
 let form = event.target;
 var product_handle = $("body").attr("product-handle");

  $.get(`/products/${product_handle}?variant=${variant.id}`, function (data) {
    $(".pdp-ingredients_wrapper")?.html(
      $(data).find(".pdp-ingredients_wrapper").html()
    );
    setTimeout(function() {
      if ($('.pdp-ingredients_items-list').hasClass('slick-initialized')) {
        $('.pdp-ingredients_items-list').slick('unslick');
      }
      $('.pdp-ingredients_items-list').slick({
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        autoplay: true,
        infinite: true,
        // pauseOnHover: true
      });
    }, 100);
  });

  var varmetadata = JSON.parse($('#variantmetaJson').html());
  console.log(varmetadata)
  if(varmetadata.variants[variant.id].content != null){
    $('[data-variant-text]').html(varmetadata.variants[variant.id].content).show();
  }else{
    $('[data-variant-text]').hide();
  }  
});
$(document).ready(function(){

  function formatMoney(cents, format = "") {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
    function defaultTo(value2, defaultValue) {
      return value2 == null || value2 !== value2 ? defaultValue : value2;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ",");
      decimal = defaultTo(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 0, "'");
        break;
    }
    if (formatString.indexOf("with_comma_separator") !== -1) {
      return formatString.replace(placeholderRegex, value);
    } else {
      return formatString.replace(placeholderRegex, value);
    }
  }
  var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;

  // window.flyToCartBadgeFromButton = function (buttonElement, qty = 1) {
  //   const cartIcon = document.querySelector('.header__cart-count');
  //   if (!cartIcon || !buttonElement) return;

  //   const btnRect = buttonElement.getBoundingClientRect();
  //   const cartRect = cartIcon.getBoundingClientRect();

  //   const badge = document.createElement("div");
  //   badge.classList.add("fly-badge");
  //   badge.textContent = `+${qty}`;

  //   const startX = btnRect.left + btnRect.width / 2;
  //   const startY = btnRect.top + btnRect.height / 2;

  //   badge.style.left = startX + "px";
  //   badge.style.top = startY + "px";

  //   const dx = cartRect.left - startX;
  //   const dy = cartRect.top - startY;

  //   badge.style.setProperty('--dx', dx + "px");
  //   badge.style.setProperty('--dy', dy + "px");

  //   document.body.appendChild(badge);

  //   setTimeout(() => badge.remove(), 800);
  // };

  
  
  $('body').on('click', '.mini-cart-drawer-subtotal', function() {
    $('.cart-payment-summary_main').slideToggle();
    $('.mini-cart-drawer-summary-toggle-icon').toggleClass('active');
  })

  $('.boxed-image-slide .image-slider-wp').slick({
    autoplay: false,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false
  });

  var $customslideshow = $(".custom-slideshow__slide-list");
  let defaultSlideTime = 7.5; // Default slide duration in seconds

  $customslideshow.on('init', function(event, slick){
    if (slick.slideCount <= 1) {
      $(this).find('.slick-dots').hide();
    }
  });
  
  // Initialize Slick Slider
  $customslideshow.slick({
    autoplay: true,
    autoplaySpeed: defaultSlideTime * 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    swipe: true,
    infinite: true,
    swipeToSlide: true,
    adaptiveHeight: true,
    pauseOnHover: false
  });
  
  // Function to restart video playback
  function restartVideo(video) {
    video.currentTime = 0;
    video.play();
  }
  
  // Function to get the active video (desktop or mobile)
  function getActiveVideo($slide) {
    // Select the visible video element
    return $slide.find(".video_mainparent").filter(function() {
      return $(this).css("display") !== "none"; // Only return visible video
    }); // Get the DOM element
  }
  
  // Set animation duration for dots based on slide type
  $customslideshow.find(".slick-dots li").each(function (i) {
    let $currentSlide = $customslideshow.find(`.slick-slide[data-slick-index='${i}']`);
    if($currentSlide.find('video').length > 0){
      let activeVideo = $currentSlide.find("video").get(0);
      let duration = activeVideo ? activeVideo.duration || defaultSlideTime : defaultSlideTime;
      $(this).css("--animation-duration", duration + "s");  
    }else{
      let duration = defaultSlideTime;
      $(this).css("--animation-duration", duration + "s");  
    }
    
  });
  
  // Handle Slide Change
  function updateSlideTiming(slideIndex) {
    let $currentSlide = $customslideshow.find(`.slick-slide[data-slick-index='${slideIndex}']`);
    let activeVideo = getActiveVideo($currentSlide).find("video").get(0);
  
    if (activeVideo) {
      setTimeout(() => restartVideo(activeVideo), 100);
      $customslideshow.slick("slickPause"); // Pause autoplay while video plays
    } else {
      $customslideshow.slick("slickPlay"); // Resume autoplay for image slides
    }
  }
  
  // Detect Videos and Handle Autoplay Behavior
  $customslideshow.find("video").each(function () {
    let video = $(this).get(0);
  
    video.addEventListener("play", function () {
      $customslideshow.slick("slickPause"); // Pause autoplay when video starts
    });
  
    video.addEventListener("ended", function () {
      console.log("Video Ended - Moving to Next Slide");
      $customslideshow.slick("slickNext"); // Move to the next slide immediately
    });
  });
  
  // Before Slide Change: Reset any playing video
  $customslideshow.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
    let currentSlideEl = $(slick.$slides[currentSlide]);
    var activevideo = getActiveVideo(currentSlideEl);
    $(activevideo).find("video").each(function () {
      this.pause();
      this.currentTime = 0;
    });
  
    // Set animation and autoplay behavior based on the next slide
    updateSlideTiming(nextSlide);
  });
  
  // Handle Dot Clicks for Manual Navigation
  $(".custom-slideshow__slide-list .slick-dots li").on("click", function () {
    let dotIndex = $(this).index();
    console.log("Dot clicked, moving to slide: " + dotIndex);
    
    updateSlideTiming(dotIndex); // Ensure correct autoplay behavior when clicking dots
  });

  $('.founder-content-slider').slick({
    fade: true,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    swipe: true,
    infinite: false,
    swipeToSlide: true,
    adaptiveHeight: false,
    pauseOnHover: false,
    prevArrow:"<p class='arow-left'><img src='https://cdn.shopify.com/s/files/1/2964/6296/files/arow-left.png?v=1651059901' width='24' height='27' loading='lazy'></p>",
    nextArrow:"<p class='arow-right'><img src='https://cdn.shopify.com/s/files/1/2964/6296/files/arow-right.png?v=1651059897' width='24' height='27' loading='lazy'></p>"
  });

  $('.slick-slider-outer').slick({
    centerMode: true,
    centerPadding: "16%",
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    swipe: true,
    infinite: true,
    loop: true,  
    swipeToSlide: true,
    adaptiveHeight: true,
    prevArrow:"<p class='arow-left'><img src='https://cdn.shopify.com/s/files/1/2964/6296/files/arow-left.png?v=1651059901' width='24' height='27' loading='lazy'></p>",
    nextArrow:"<p class='arow-right'><img src='https://cdn.shopify.com/s/files/1/2964/6296/files/arow-right.png?v=1651059897' width='24' height='27' loading='lazy'></p>",  
    responsive: [
     {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
       {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }
    ],  
  });   

  $('.pdp-ingredients_items-list').slick({
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: true,
    infinite: true,
    // pauseOnHover: true
  });

  
  $('.template-collection-subscription').on('click','.collection-sub-total-popover_wrapper .collection-view-cart',function(){
    document.getElementById('mini-cart').open = true;
  });
  
  $('.oclc-wrap').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: true,
    arrows: false, 
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
        }
    },
     {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        }
      }
    ],  
  });

  $('body').on('click','.custom_err_button', function(e){
    e.preventDefault();
    $('.carterr_msg.custom_for_trail').remove();
    $(this).before('<p class="carterr_msg custom_for_trail">You can not checkout with more than one quantity of TRIAL items.</p>');
    setTimeout(function(){
      $('.carterr_msg.custom_for_trail').remove();
    },5000);
  });

  //SUBSCRIPTION COLLECTION PAGE
  $('.product-item_short-desc-heading').click(function(){
     $(this).toggleClass('active');
     $(this).next('.product-item_short-desc-text').slideToggle();
  });  

  
  $('.accordion__header').click(function(e) {
    e.preventDefault();
    var currentIsActive = $(this).hasClass('is-active');
    $(this).parent('.accordion').find('> *').removeClass('is-active');
    if(currentIsActive != 1) {
    $(this).addClass('is-active');
    $(this).next('.accordion__body').addClass('is-active');
    }
  });

  $('.collect-card-slider').slick({
    slidesToShow: 4,
    dots: false,
    arrows: true,
    infinite: true,
    loop: true,  
    adaptiveHeight: true,  
    responsive: [
       {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ],  
  });

  $('.flip_slider').slick({
    slidesToShow: 3,
    dots: false,  
    arrows: true,
    infinite: true,
    loop: true,  
    adaptiveHeight: true,  
    responsive: [
       {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ],  
  
   
  });

  $('.cb-product-item_images').slick({
    slidesToShow: 1,
    dots: true,  
    arrows: false,
  });
  $('.super-product-item_images').slick({
    slidesToShow: 1,
    dots: true,  
    arrows: false,
  });

  $('.video-list-wrapper').slick({
     centerMode: true,
     slidesToShow: 5,
     slidesToScroll: 1,
     arrows: true,
     dots: true,
     infinite:true,
     adaptiveHeight: true,
     autoplay: false,
     autoplaySpeed: 2000,
     focusOnSelect: true,
     slide: '.video-list-item',
     responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 520,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
   });

  $(".video-list-wrapper").on("afterChange", function (event, slick, currentSlide, nextSlide){
    $('.video-list').find('.video-list-item').each(function(){
      var vdid = $(this).find('.vl-item_video').attr('id');
      var vvdid = $(this).find('.video-list-item_wrap').attr('id');
      document.getElementById(vdid)?.pause();
      document.getElementById(vvdid)?.classList.add('paused');
    }); 
    document.querySelector(".video-list-item.slick-current video").play();
    document.querySelector(".video-list-item.slick-current .video-list-item_wrap").classList.remove('paused');
  });

  $('body').on('click','.popover.custom_pop .not_add_continue', function(){
    $(this).closest('.popover.custom_pop').removeAttr('open').attr('hidden','');
    $('[data-product-add-to-cart-button]#AddToCart').removeClass('has_selection').trigger('click');
    setTimeout(function(){
      $('[data-product-add-to-cart-button]#AddToCart').addClass('has_selection');
    },2000);
  });

  $('body').on('click','.popover.custom_pop .add_continue', function(){
    $('.err_msg').remove();
    var items = [];
    if($(this).closest('.popover__content').find('[name="additional_item"]:checked').length > 0){
      $(this).closest('.popover__content').find('[name="additional_item"]:checked').each(function(i,v){
      var val = $(this).attr('data-vid');
      
      items.push({
        quantity: 1,
        id: val          
      });
    });        
    var data = {items};
    // var data = theme.utils.serialize(this.form);
   
    fetch('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify(data),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(function(data) {
      if (data.status === 422) {
        this.error(data);
      } else {
        console.log('jikooko');
        $('.popover.custom_pop').removeAttr('open').attr('hidden','');
        console.log($('[data-product-add-to-cart-button]#AddToCart').length)
        $('[data-product-add-to-cart-button]#AddToCart').addClass('sub_added').trigger('click');
        setTimeout(function(){
          $('[data-product-add-to-cart-button]#AddToCart').removeClass('sub_added');
        },2000);
      }
      
    }.bind(this));   
    }else{
      $(this).closest('.submit-content_wp').before('<p class="err_msg">Please select any item!</p>');
    }    
  });

  $('.quantity-selector__button.minus').click(function(){
    if($(this).next('.quantity-selector__input').val() >= 2 && ($(this).next('.quantity-selector__input').attr('min') == $(this).next('.quantity-selector__input').val())){
      $("body").append(`<div class="qty-error-overlay">
          <div class="qty-error-message">            
            <p>This product has an MOQ of 2. Buy worry-free, and get a full refund if you do not like the taste.</p>
            <a href="javascript:void(0);" class="close-btn">
              <svg focusable="false" width="14" height="14" class="icon icon--close   " viewBox="0 0 14 14">
                <path d="M13 13L1 1M13 1L1 13" stroke="currentColor" stroke-width="2" fill="none"></path>
              </svg>
            </a>
            </div>            
          </div>`);
        setTimeout(function() {
            // $( ".qty-error-overlay" ).remove();
        }, 15000) 
       }
    });

   $('body').on('click','.qty-error-overlay .qty-error-message .close-btn', function(){    
      $(this).closest(".qty-error-overlay").remove();
  });

  $('body').on('change','#discount_code',function(){
    var val = $(this).val();
    if(val != 'none'){
      $('.discount-code-apply-wrapper').find('.discount-code').val(val);
      $('.discount-code-apply-wrapper').find('#discount_code_btn').removeAttr('disabled').trigger('click');
    }else{      
      $('.discount-code-apply-wrapper').find('.success-msg').hide();
      $('.discount-price-wrapper').find('.discount-price,.total-price').hide();
      $('.err-msg').hide();
      $('.err-msg').show().html('The requirements to avail the discount have not been fulfilled.');
      setCookie('discountcode',false,-1);      
    }
  });

  function setCookie(name, value, days) {
      var d = new Date;
      d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
      document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
  }

  $('body').on('click','.bogo_link .link_main', function(){
    var submitButtons = $(this);    
    var vid = $(this).attr('data-pid');
    submitButtons.find('.content_text').attr('hidden','true');
    submitButtons.find('.line-item__loader_custom').removeAttr('hidden');
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: vid,
      },
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);     
        submitButtons.after('<p class="add_err_msg">'+response.description+'</p>');
        submitButtons.find('.content_text').removeAttr('hidden');
        submitButtons.find('.line-item__loader_custom').removeAttr('hidden');        
      },
      success: function(data){   
        setCookie('discountcode',false,-1);                
        fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
          const cartContent = await response2.json();
         document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
            bubbles: true,
            detail: {
              cart: cartContent
            }
          }));
          document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
              cart: cartContent,
              replacementDelay: 600
            }
          }));
          submitButtons.find('.content_text').removeAttr('hidden');
        submitButtons.find('.line-item__loader_custom').attr('hidden',true);
        });
      }
    });
  });

  // if($('.recommandation-category-list_desktop').length > 0){
  //   var stckytop = $('.recommandation-category-list_desktop').offset().top - $('.shopify-section--header').outerHeight() + $('.recommandation-category-list_desktop').outerHeight();
  //     var sht = $('.recommandation-category-list_desktop').outerHeight() + 5;
  //   $(window).scroll(function(){
  //     if ($(window).scrollTop() >= stckytop) {
  //       // $('.shopify-section--main-collection').attr('style','padding-top: '+sht+'px;');
  //       $('.recommandation-category-list_sticky').addClass('fixed-header');
        
  //     }else {
  //       // $('.shopify-section--main-collection').removeAttr('style');
  //       $('.recommandation-category-list_sticky').removeClass('fixed-header');
        
  //     }
  //   });
  // }
 
  if(window.location.hash === '#opencartdrawer') {
    document.getElementById('mini-cart').open = true;
    history.pushState("", document.title, window.location.pathname + window.location.search);
  }

  $('body').on('click','.pdp-ingredients .all_ingrd_btn', function(){
    $('.ingrd_model [data-content]').html($(this).closest('.all_ingredients_button').find('[data-ingpopup-content]').html());
    $('.ingrd_model_overlay,.ingrd_model').addClass('active');
  });

  $('body').on('click','.pdp-ingredients .close_button', function(){
    $('.ingrd_model_overlay,.ingrd_model').removeClass('active');
  });

  
  $('.only_one_product_modal_opner').click(function(e){
    e.preventDefault();
    console.log('000000111');
    $('#only-one_product_modal').attr("open",true);
    setTimeout(function(){ 
      $('#only-one_product_modal').removeAttr("open",true);
     }, 2500);  
  });
  $('body').on('click', '.only_one_product.only_one_product-added button[type="submit"]', function(e) {
    $('#only-one_product_modal').attr("open",true);
    setTimeout(function(){ 
      $('#only-one_product_modal').removeAttr("open",true);
     }, 2500);
  });

  var page_url = location.href;
  var redirected_collections = window.themeVariables.settings.redirected_collections;
  if(redirected_collections.length){  
    $(redirected_collections).each(function(index,item) {
      // console.log('0000000000000',index,page_url,item.handle,page_url.includes(item.handle));
      if(page_url.includes(`/collections/${item.handle}`)){
        window.location.replace(`/collections/all-collections#${item.handle}`)
      }
    });
  }
  // $('.single-collection_row').slick({
  //   slidesToShow: 4,
  //   slidesToScroll: 1,
  //   dots: true,
  //   arrows: false, 
  //   infinite:false,
  //   responsive: [
  //     {
  //       breakpoint: 1199,
  //       settings: {
  //         slidesToShow: 3,
  //       }
  //   },
  //     {
  //       breakpoint: 767,
  //       settings: {
  //         slidesToShow: 2,
  //       }
  //     }
  //   ],  
  // });

  var swiperCollection = new Swiper(".single-collection_row", {
    slidesPerView: 4,
    spaceBetween: 15,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 2,
        spaceBetween: 10
      },
      767: {
        slidesPerView: 3
      },
      1200: {
        slidesPerView: 4
      }
    }
  });

  var swiperFacet = new Swiper(".facet_slideshow_wrapper", {
    slidesPerView: 1,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
  
  $('.fun-facts_row').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: true, 
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 2,
          }
      },
       {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
          }
        }
      ],  
    });

    $('.image-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      responsive: [
       {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
          }
        }
      ],  
    });
    $('.news-image-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      responsive: [
       {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
          }
        }
      ],
    });
    $('.troo-testimonial_main').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: false, 
      centerMode: true,
      responsive: [
       {
          breakpoint: 740,
          settings: {
            infinite: false,
            slidesToShow: 1,
          }
        }
      ],  
    });
    $('.officially-amazing_main').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: true,
      arrows: false, 
      centerMode: false,
      responsive: [
        {
          breakpoint: 767, // Example breakpoint for mobile
          settings: "unslick" // This will unslick the slider at or below 767px
        }
        // You can add more breakpoints if needed
      ]
    });

    if($('.product-form__buy-buttons').length > 0){
      var $el = $('.product-form__buy-buttons');
      var $el_position = $('.product-form__buy-buttons').offset().top
      $(window).on('scroll resize', function () {
        if (!$el.length) return;

        if(window.scrollY > $el_position){
          $('.product-form__buy-buttons').addClass('sticky');
        }else{
          $('.product-form__buy-buttons').removeClass('sticky');
        }
      });
    }
  

  function addFreeProduct(event, cart) {
    const settings = window.themeVariables?.settings;
    if (!settings) return;

    const total = cart.total_price;

    // Build threshold configuration
    const thresholds = [
      { id: settings?.free_item1?.variants?.[0]?.id, price: parseInt(settings?.price_threshhold1 || "0") * 100 },
      { id: settings?.free_item2?.variants?.[0]?.id, price: parseInt(settings?.price_threshhold2 || "0") * 100 },
      { id: settings?.free_item3?.variants?.[0]?.id, price: parseInt(settings?.price_threshhold3 || "0") * 100 },
      { id: settings?.free_item4?.variants?.[0]?.id, price: parseInt(settings?.price_threshhold4 || "0") * 100 },
      { id: settings?.free_item5?.variants?.[0]?.id, price: parseInt(settings?.price_threshhold5 || "0") * 100 }
    ];

    let itemsToAdd = [];
    let updateData = {};

    thresholds.forEach((threshold, index) => {
      if (!threshold.id) return;

      const lineIndex = cart.items.findIndex(item => item.variant_id === threshold.id);
      const lineItem = cart.items[lineIndex];

      // Check if all previous thresholds are satisfied
      const previousSatisfied = thresholds
        .slice(0, index)
        .every(t => total >= t.price);

      // Add free item
      if (total >= threshold.price && lineIndex === -1 && previousSatisfied) {
        itemsToAdd.push({
          quantity: 1,
          id: threshold.id,
          properties: {
            _type: "free_gift"
          }
        });
      }

      // Remove free item if threshold not met
      if (total < threshold.price && lineIndex !== -1) {
        updateData[lineItem.key] = 0;
      }
    });

    // Add items
    if (itemsToAdd.length > 0) {
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        async: false,
        data: { items: itemsToAdd },
        dataType: "json",
        error: function (jqXHR) {
          var response = $.parseJSON(jqXHR.responseText);
          console.log("Free Gift Error", response.description);
        },
        success: function () {
          refreshCart();
        }
      });
    }

    // Remove items
    if (Object.keys(updateData).length > 0) {
      $.ajax({
        type: "POST",
        url: "/cart/update.js",
        data: { updates: updateData },
        dataType: "json",
        async: false,
        success: function () {
          refreshCart();
        },
        error: function (jqXHR) {
          console.log(jqXHR);
        }
      });
    }

    function refreshCart() {
      if (document.body.classList.contains("template-cart")) {
        location.reload();
      } else {
        $.getJSON("/cart.js", function (cart) {
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true,
              detail: { cart }
            })
          );
        });
      }
    }
  }


  document.addEventListener('cart:refresh', function(event) {
    console.log('event',event);
    var cart = event.detail.cart; // Get the updated content of the cart
    addFreeProduct(event,cart);
  });
    

  function tabbingLeftScroll(){
    var prevAllElementWidth = 0;
    $('.sticky-product-list-category_link.active').parent().prevAll().each(function() {
        var elementWidth = $(this).outerWidth();
        prevAllElementWidth = prevAllElementWidth + elementWidth;
    });  
    var $scroller = $('.sticky-product-list-category');
    var divIdx = 4;    
    var scrollTo = prevAllElementWidth - 30
    $scroller.animate({'scrollLeft': scrollTo}, 000);
  }
  if($('.product-list-category').length > 0){
    var stckytop = $('.product-list-category').offset().top - $('.shopify-section--header').outerHeight() + $('.product-list-category').outerHeight();
    $(window).scroll(function(){
      if ($(window).scrollTop() >= stckytop) {
        $('.sticky-product-list-category').addClass('active');
      }else {
        $('.sticky-product-list-category').removeClass('active');
        
      }
    });
  }
  $('body').on('click','.product_with_tab a[href^="#"]',function (e) {
    e.preventDefault();
    $('html').removeClass('lock-all');
    $('.sticky-product-list-category_link').removeClass('active');
    $('.product-list-category_link').removeClass('active');
    $(`a[href="${this.hash}"]`).addClass('active');
    $('html, body').animate({
      scrollTop: $(this.hash).offset().top-150
    }, 800);
    window.location.hash = this.hash;
    tabbingLeftScroll();
    
  });

  $('body').on('click', '.mini_cart-category-content_link', function() {
    document.getElementById('mini-cart').open = false; 
    $('html, body').animate({
      scrollTop: $(this.hash).offset().top-150
    }, 800);
    window.location.hash = this.hash;
  });
  window.addEventListener('load', () => {
    // Use JavaScript code here.
    console.log('page loaded');
    if(window.location.href.includes("#")){  
      $(`a[href="#${window.location.href.split("#")[1]}"]`).trigger("click");
    }
    // setTimeout(function() {
    // }, 10);
  });

  if($('.sticky-product-list-category_link.active').length > 0){
  setTimeout(function() { 
      tabbingLeftScroll();
    }, 1000); 
  }

  var lastId,
      topMenu = $(".sticky-product-list-category"),
      mainMenu = $(".product-list-category"),
      topMenuHeight = window.outerHeight - 150,
      menuItems = topMenu.find("a"),
      mainMenuItems = topMenu.find("a"),
      scrollItems = menuItems.map(function(){
        var item = $($(this).attr("href"));
        if (item.length) { return item; }
      });

  // Bind to scroll
  $(window).scroll(function(){
    // Get container scroll position
    var fromTop = $(this).scrollTop()+topMenuHeight;
    
    // Get id of current scroll item
    var cur = scrollItems.map(function(){
      if ($(this).offset().top < fromTop)
        return this;
    });
    // console.log('cur',cur);
    // Get the id of the current element
    cur = cur[cur.length-1];
    var id = cur && cur.length ? cur[0].id : "";
    
    if (lastId !== id) {
        lastId = id;
        // Set/remove active class
        // menuItems.removeClass("active").parent().end().filter(`[href='#${id}']`).addClass("active");
        $('.product-list-category_link').removeClass("active");
        $(`.product-list-category_link[href='#${id}']`).addClass("active");
      
        $('.sticky-product-list-category_link').removeClass("active");
        $(`.sticky-product-list-category_link[href='#${id}']`).addClass("active");
        tabbingLeftScroll();
    }                   
  });

  $('.see-all-product_btn').on('click',function (e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: $('#product-list-category').offset().top-150
    }, 800);  
  });

  if($('.sticky_category-content-wp.active').length > 0 && $('.sticky_category-content-wp.active').length > 0){
  setTimeout(function() { 
      var $scroller = $('.recommandation-category-list_sticky');
      var divIdx = 4;          
      var scrollTo = $('.sticky_category-content-wp.active').position().left - 150;                   
      console.log(scrollTo);
      $scroller.animate({'scrollLeft': scrollTo}, 500);
    }, 1000); 
  }  

  // ----------------------------
  $('.cs-item_content-text_read').click(function(){
    $(this).parents('.cs-item_content').find('.cs-item_content-text').toggle();
      if ($(this).text() == "Read More") {
      $(this).text("Read Less")
    } else {
      $(this).text("Read More")
    }
  });
  $('.product-content_more-less-button').click(function() {
      $(this).prev('.product-content_text-item_content').toggleClass('active');
    if ($(this).text() == "Read more") {
      $(this).text("Read less")
    } else {
      $(this).text("Read more")
    }
  });



  $('body').on('click','.pdp-tabbing_wrapper a[href^="#"]',function (e) {
    e.preventDefault();
    $('.pdp-tabbing_item--link').removeClass('active');
    $(`a[href="${this.hash}"]`).addClass('active');
    
    // $('html, body').stop().animate({
    //   'scrollTop': $(this.hash).offset().top - 150
    // }, 900, 'swing', function () {
    //   window.location.hash = this.hash;
    // });
    $('html, body').animate({
      scrollTop: $(this.hash).offset().top-150
    }, 800);
  });

  $('.image-scrolling-list').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: true,
    arrows: false, 
    centerMode: false,
    responsive: [
      {
        breakpoint: 767, 
        settings: "unslick"
      }
    ]
  });

  window.addEventListener('scroll', function () {
      const btn = document.getElementById('backToTop');
      if (window.pageYOffset > 300) {
          btn.classList.add('show');
      } else {
          btn.classList.remove('show');
      }
  });

});

$(document).on('click', '.lab-report-block-download', function (e) {
  e.preventDefault();
  var url = $(this).attr('href');
  var name = url.split('/').pop().split('?')[0];

  fetch(url)
    .then(function (res) { return res.blob(); })
    .then(function (blob) {
      var objectUrl = URL.createObjectURL(blob);
      var $a = $('<a>', { href: objectUrl, download: name }).appendTo('body');
      $a[0].click();
      $a.remove();
      URL.revokeObjectURL(objectUrl);
    });
});

